import { render, staticRenderFns } from "./Kontragent.vue?vue&type=template&id=50eed070&scoped=true"
import script from "./Kontragent.vue?vue&type=script&lang=js"
export * from "./Kontragent.vue?vue&type=script&lang=js"
import style0 from "./Kontragent.vue?vue&type=style&index=0&id=50eed070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eed070",
  null
  
)

export default component.exports